import Toggle from "../toggle/Toggle";
import Tooltip from "../tooltip/Tooltip";
import "./toggle-field.css";

/**
 * Toggle with label and optional description. Layout is fixed: switch on the left,
 * title and helper text on the right (vertically centered as a block).
 *
 * @param {Object} props
 * @param {React.ReactNode} props.label - Primary label beside the toggle
 * @param {React.ReactNode} [props.description] - Secondary line(s) under the label
 * @param {boolean} [props.checked] - Controlled toggle state
 * @param {Function} [props.onChange] - Called with the new boolean value
 * @param {boolean} [props.disabled]
 * @param {string} [props.disabledTooltip] - Shown on hover when disabled (e.g. admin lockout)
 * @param {string} [props.className] - Root wrapper classes
 * @param {string} [props.tooltipPosition] - Tooltip placement when disabledTooltip is set
 */
export default function ToggleField({
  label,
  description,
  checked,
  onChange,
  disabled = false,
  disabledTooltip,
  className = "",
  tooltipPosition = "top",
  id,
  ...toggleProps
}) {
  const labelId = id ? `${id}-label` : undefined;

  const toggle = (
    <Toggle
      id={id}
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      aria-labelledby={labelId}
      {...toggleProps}
    />
  );

  const toggleControl =
    disabled && disabledTooltip ? (
      <Tooltip content={disabledTooltip} position={tooltipPosition}>
        {toggle}
      </Tooltip>
    ) : (
      toggle
    );

  return (
    <div className={`toggle-field ${className}`.trim()}>
      {toggleControl}
      <div className="toggle-field__text">
        {label != null && label !== "" && (
          <div className="toggle-field__label" id={labelId}>
            {label}
          </div>
        )}
        {description != null && description !== "" && (
          <div className="toggle-field__description">{description}</div>
        )}
      </div>
    </div>
  );
}
